// Copied from ds/src/configs/breakpoints.ts
export const breakpoints = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
} as const;

export type Breakpoint = keyof typeof breakpoints;
